import { EditOutlined } from '@ant-design/icons';
import { COLOR_TOOLTIP } from '@constants/common';
import { formatAssetNo } from '@utils/helpers';
import { Button, Tooltip } from 'antd';
import { TableProps } from 'antd/lib';
import {
  DISPLAY_EMPTY,
  MANAGEMENT_SEAL_REQUEST_CONSTANT,
  TSealRequestRow,
} from './constant';

const { TABLE_HEADER } = MANAGEMENT_SEAL_REQUEST_CONSTANT;

const renderWithTooltip = (value?: string | null) => {
  if (!value) {
    return DISPLAY_EMPTY;
  }

  return (
    <div className="list-page_ellipsis">
      <Tooltip
        color="white"
        overlayClassName="common_custom-tooltip"
        title={value}
        overlayInnerStyle={{
          color: COLOR_TOOLTIP,
        }}
      >
        {value}
      </Tooltip>
    </div>
  );
};

const renderStore = (storeCode?: string | null, storeName?: string | null) => {
  if (!storeCode && !storeName) {
    return DISPLAY_EMPTY;
  }

  return `${storeCode || ''} ${storeName || ''}`.trim();
};

export const getColumns = ({
  handleOpenQuantityEdit,
}: {
  handleOpenQuantityEdit: (record: TSealRequestRow) => void;
}): TableProps<TSealRequestRow>['columns'] => {
  return [
    {
      title: TABLE_HEADER.NO,
      key: 'no',
      width: 80,
      align: 'right',
      render: (_value, _record, index) => index + 1,
    },
    {
      title: TABLE_HEADER.STORE,
      key: 'store',
      dataIndex: 'storeCode',
      width: 220,
      align: 'left',
      render: (_value, record) => {
        return renderWithTooltip(
          renderStore(record.storeCode, record.storeName)
        );
      },
    },
    {
      title: TABLE_HEADER.ASSET_NO,
      key: 'assetNo',
      dataIndex: 'assetNo',
      width: 180,
      align: 'left',
      render: (value) => renderWithTooltip(formatAssetNo(value) || undefined),
    },
    {
      title: TABLE_HEADER.ASSET_NAME,
      key: 'assetName',
      dataIndex: 'assetName',
      width: 360,
      align: 'left',
      render: (value) => renderWithTooltip(value),
    },
    {
      title: TABLE_HEADER.QUANTITY,
      key: 'quantity',
      dataIndex: 'quantity',
      width: 120,
      align: 'right',
      render: (value: number | null) => {
        if (value === null || value === undefined) {
          return DISPLAY_EMPTY;
        }

        return value;
      },
    },
    {
      title: TABLE_HEADER.EDIT,
      key: 'edit',
      dataIndex: 'edit',
      width: 90,
      align: 'center',
      render: (_value, record) => {
        return (
          <Button
            type="text"
            className="management-seal-request_edit-button"
            onClick={() => handleOpenQuantityEdit(record)}
            aria-label={`${TABLE_HEADER.EDIT} ${
              record.assetNo || record.requestCode
            }`}
          >
            <EditOutlined />
          </Button>
        );
      },
    },
  ];
};
